export const env = () => {
    return process.env.REACT_APP_ENV || 'dev';
};